module.exports = __webpack_public_path__ + "media/src/images/balloons/womans_day_headline_en-fe959d4c8071c42cdf7e6b3ea8ab5d71.png";